import { NS_SVG, XLINK_SVG } from "../constants";

export function SVG_CreateSVGElement(width, height) {
  //, transparent)
  var svg = document.createElementNS(NS_SVG, "svg");

  var x = svg.getAttribute("xmlns");
  if (x == null) svg.setAttribute("xmlns", NS_SVG);
  svg.setAttribute("xmlns:xlink", XLINK_SVG);
  svg.setAttribute("version", "1.1");

  svg.setAttribute("width", width);
  svg.setAttribute("height", height);

  svg.style.left = "0px";
  svg.style.top = "0px";
  svg.style.position = "absolute";

  var defs = document.createElementNS(NS_SVG, "defs");
  svg.appendChild(defs);
  svg["defs"] = defs;

  //if (!transparent)
  //      SVG_FillRect(0,0,width,height, "#FFFFFF", svg);

  return svg;
}
